import { Grid } from "@mui/material";
import lpIcon from "assets/loyalty-icon-single-v2.png";
import Button from "components/Buttons/ThemeButton";
import { useDIPAction } from "components/DIP/hooks";
import { useAppSelector } from "hooks";
import { Fragment } from "react";
import { selectDipState } from "redux/slices";
import { ClubGiftContainer, Text } from "./styles";
import { useDIPRewardsV2 } from "components/DIP/hooks/useDIPRewardsV2";
import { DipButton } from "interfaces/dip/dip";

interface ClubGiftProps {}

export const ClubGift: React.FC<ClubGiftProps> = () => {
	const { currentDip } = useAppSelector(selectDipState);

	if (!currentDip || !currentDip?.buttons) {
		return <Fragment />;
	}

	const { buttons: data, dip } = currentDip;

	return (
		<ClubGiftContainer
			background={dip.imageUrl}
			sx={{ paintOrder: "stroke fill" }}
		>
			{data.map((item) => (
				<ClubGiftItem key={item.id} item={item} />
			))}
		</ClubGiftContainer>
	);
};

interface ClubGiftItemProps {
	item: DipButton;
}

const ClubGiftItem: React.FC<ClubGiftItemProps> = ({ item }) => {
	const { claimRewardProcess } = useAppSelector(selectDipState);
	// Temporarily hidden per product request; restore this state with the JSX below
	// to re-enable the Poi's Bounty messaging.
	// const { canContribute: isPoisActive } = useAppSelector(
	// 	selectPoisBountyV3State
	// );
	const { onAction } = useDIPAction();
	const { loading } = claimRewardProcess;
	const { price, rewards, loyaltyPointReward } = useDIPRewardsV2(item);

	return (
		<div key={item.id}>
			<Grid container className="item-container large">
				<Grid container spacing={1} justifyContent="center" alignItems="center">
					{rewards.map((reward) => {
						return (
							<Grid
								key={reward.id}
								item
								display="flex"
								flexDirection="column"
								alignItems="center"
								justifyContent="center"
							>
								<img src={reward.imageUrl} alt="" />
								<Text type="primary" textAlign="center">
									{reward.description}
								</Text>
							</Grid>
						);
					})}
				</Grid>
			</Grid>
			<Grid item mt={0.5} ml={1}>
				<Text type="primary" fontSize="15px">
					You also get:
				</Text>
			</Grid>
			<Grid container className="item-container small">
				<Grid container alignItems="center" justifyContent="center" spacing={1}>
					<Grid item>
						<img src={lpIcon} alt="Loyalty points image" />
					</Grid>
					<Grid item>
						<Text type="primary" fontSize="20px">
							{loyaltyPointReward?.toLocaleString("en-US")} Loyalty points
						</Text>
						{/*
							{isPoisActive && (
								<Text
									fontFamily="Inter"
									color="#FBBD05"
									fontSize="16px"
									fontWeight={700}
								>
									Contribute to Poi&apos;s Bounty
								</Text>
							)}
						*/}
					</Grid>
				</Grid>
			</Grid>
			<Button onClick={() => onAction(item, price)} disabled={loading}>
				{price} USD
			</Button>
		</div>
	);
};
